module.exports = __webpack_public_path__ + "img/llamadobano.fa320a7c.gif";